import { render, staticRenderFns } from "./transverseAside.vue?vue&type=template&id=35275a11&scoped=true"
import script from "./transverseAside.vue?vue&type=script&lang=js"
export * from "./transverseAside.vue?vue&type=script&lang=js"
import style0 from "./transverseAside.vue?vue&type=style&index=0&id=35275a11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35275a11",
  null
  
)

export default component.exports